import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Skeleton } from "@mui/material";
import dayjs from "dayjs";
// import { Table } from "antd";
import { getMedicalTestCatDetail } from "../../connections/getMedicalTestCatDetail";
import { deleteMedicalTestCat } from "../../connections/deleteMedicalTestCat";
import { toast } from "react-toastify";
import { imagesend } from "../imagepath";
import { formatDateTime } from "../../utils/constant/constant";

const ShowMedicalTestCategory = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const { id } = useParams();
  const [deleteId, setDeleteId] = useState(null);
  const navigate = useNavigate();
  const { data: medicalTestCatDetailsData, isLoading } = useQuery({
    queryKey: ["getMedicalTestCatDetail", id],
    queryFn: () => getMedicalTestCatDetail(user?.token, id),
    enabled: !!id,

    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const handleDeleteMedicalTestCat = async (e) => {
    e.preventDefault();

    try {
      const data = await deleteMedicalTestCat(user?.token, deleteId);
      if (data.status.status === "SUCCESS") {
        toast.success("Occupation Deleted Successfully");
        navigate("/admin/medical_tests_category");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  // const columns = [
  //   {
  //     title: "Name",
  //     dataIndex: "name",
  //   },
  //   {
  //     title: "Code",
  //     dataIndex: "code",
  //   },
  //   {
  //     title: "Lab",
  //     dataIndex: "lab",
  //   },
  //   {
  //     title: "Lab Id",
  //     dataIndex: "lab_id",
  //   },
  //   {
  //     title: "Created At",
  //     dataIndex: "created_at",
  //     render: (date) => (
  //       <>
  //         {date}
  //       </>
  //     ),
  //   },
  //   {
  //     title: "Updated At",
  //     dataIndex: "updated_at",
  //     render: (date) => (
  //       <>
  //         {date}
  //       </>
  //     ),
  //   },
  // ];
  return (
    <>
      <Header />
      <Sidebar activeClassName="medical-test-cat-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to={-1}>Medical Test Category Details</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* content Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="doctor-table-blk"
                          >
                            <h3>Medical Test Category Details</h3>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                              className="doctor-search-blk"
                            >
                              <button
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                onClick={() => {
                                  navigate(
                                    "/admin/update-medical_tests_category",
                                    {
                                      state: medicalTestCatDetailsData,
                                    }
                                  );
                                }}
                              >
                                <i className="far fa-edit me-2" />
                                Edit
                              </button>

                              <button
                                className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#delete_patient"
                                onClick={() => {
                                  setDeleteId(medicalTestCatDetailsData?.id);
                                }}
                              >
                                <i className="fa fa-trash-alt me-2" />
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <div>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={430}
                        />
                      </div>
                    ) : (
                      <div className="content-details">
                        <div className="col-lg-12">
                          <div className="card-box">
                            <div className="card-block">
                              <ul className="personal-info">
                                <li className="pb-1">
                                  <span className="title">Name:</span>
                                  <span className="text">
                                    {medicalTestCatDetailsData?.name || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Code:</span>
                                  <span className="text">
                                    {medicalTestCatDetailsData?.code || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Lab:</span>
                                  <span className="text">
                                    {medicalTestCatDetailsData?.lab || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Lab Id:</span>
                                  <span className="text">
                                    {medicalTestCatDetailsData?.lab_id || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Created At:</span>
                                  <span className="text">
                                    {medicalTestCatDetailsData?.created_at
                                      ? formatDateTime(medicalTestCatDetailsData?.created_at)
                                      : "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Updated At:</span>
                                  <span className="text">
                                    {medicalTestCatDetailsData?.updated_at
                                      ? formatDateTime(medicalTestCatDetailsData?.updated_at)
                                      : "N/A"}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      // <div className="table-responsive">
                      //   <Table
                      //     columns={columns}
                      //     dataSource={[medicalTestCatDetailsData]}
                      //     pagination={false}
                      //     scroll={{ x: "max-content" }}
                      //   />
                      // </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button
                    onClick={handleDeleteMedicalTestCat}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default ShowMedicalTestCategory;
